import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { TagsNetworkFilterDataProviderFactory } from '../factory/TagsNetworkFilterDataProviderFactory';
import { TagsNetworkFilterBaseDataProvider } from '../dataProvider/TagsNetworkFilterBaseDataProvider';
import { TagItem } from '../../tagsManagerGrid/types';

export class TagsNetworkFilterRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TagsNetworkFilterDataProviderFactory;
  public dataProvider: TagsNetworkFilterBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TagsNetworkFilterDataProviderFactory(),
    });
  }

  async getDataForView(companyIds: Array<string>): Promise<Array<TagItem>> {
    return this.dataProvider.getDataForView(companyIds);
  }
}
